"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryAgreements = void 0;
exports.queryAgreements = `
  query getAgreements($filterByCustomerType: Int, $filterByFinancingType: Int) {
    agreements(filterByCustomerType: $filterByCustomerType, filterByFinancingType: $filterByFinancingType) {
      applicableForApplicantType
      code
      description
      financingType
      objectGroups {
        code
        name
      }
    }
  }
`;
//# sourceMappingURL=agreements.js.map